/* eslint-disable global-require */

module.exports = [
  require('./handleContractDefinitionComments'),
  require('./handleModifierInvocationComments')
];
